import {ClientSolicitationFlow, ClientSolicitationFlowForm} from "../../types/flow/flowData";
import {HttpAxiosRequest} from "../httpAxiosBase";
import {BaseResponse} from "../../types/baseEntities";


export const HttpSolicitationFlow = {
    getEndpoint: (solicitationId: number, url = ''): string => `solicitud/${solicitationId}/movimientos${url}`,
    
    getList: (solicitationId: number) : Promise<ClientSolicitationFlow[]> => {
        return HttpAxiosRequest.get(
            HttpSolicitationFlow.getEndpoint(solicitationId)
        )
    },
    
    insert: (solicitationId: number, flowData: ClientSolicitationFlowForm) : Promise<BaseResponse> => {
        return HttpAxiosRequest.post(
            HttpSolicitationFlow.getEndpoint(solicitationId),
            {...flowData}
        )
    },

    update: (solicitationId: number, flowId: number, flowData: ClientSolicitationFlowForm) : Promise<BaseResponse> => {
        return HttpAxiosRequest.put(
            HttpSolicitationFlow.getEndpoint(solicitationId, `/${flowId}`),
            {...flowData}
        )
    },

    delete: (solicitationId: number, flowId: number) : Promise<any> => {
        return HttpAxiosRequest.delete(
            HttpSolicitationFlow.getEndpoint(solicitationId, `/${flowId}`)
        )
    }
}